import Namespace from './type/Namespace';
import { ShareLinkMessengerMessage } from './type/ShareLinkMessengerMessage';

type T = (message: ShareLinkMessengerMessage) => boolean;

const f: T = (message) => message.namespace === Namespace.SHARE_LINKS_MESSENGER;

export default f;
